import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

type Props = {
  itemId: string
  workflowAssigneeId: string
}

export function useUpdateItemAssignee() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ itemId, workflowAssigneeId }: Props) => {
      const response = await axios.put(`items/${itemId}`, {
        workflow_assignee_id: workflowAssigneeId,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['workflow-log'])
    },
  })
}
